








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

var mti_metadata_pb=require('../../../mti/metadata_pb.js');
var google_protobuf_timestamp_pb=require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.mti.store.lock.LockFailureType',null,global);
goog.exportSymbol('proto.mti.store.lock.PhysicalKeyType',null,global);
goog.exportSymbol('proto.mti.store.lock.State',null,global);
goog.exportSymbol('proto.mti.store.lock.Type',null,global);











proto.mti.store.lock.State=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.lock.State,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.lock.State.displayName='proto.mti.store.lock.State';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.lock.State.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.lock.State.toObject(opt_includeInstance,this);
};











proto.mti.store.lock.State.toObject=function(includeInstance,msg){
var f,obj={
metadata:(f=msg.getMetadata())&&mti_metadata_pb.Metadata.toObject(includeInstance,f),
storeId:jspb.Message.getFieldWithDefault(msg,2,0),
serialNumber:jspb.Message.getFieldWithDefault(msg,3,""),
lockIndex:jspb.Message.getFieldWithDefault(msg,4,0),
stateUuid:msg.getStateUuid_asB64(),
stateUpdatedAt:(f=msg.getStateUpdatedAt())&&google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance,f),
type:jspb.Message.getFieldWithDefault(msg,7,0),
lockModel:jspb.Message.getFieldWithDefault(msg,8,""),
lockHardwareVersion:jspb.Message.getFieldWithDefault(msg,9,""),
lockFirmwareVersion:jspb.Message.getFieldWithDefault(msg,10,""),
lostCommunication:jspb.Message.getFieldWithDefault(msg,11,false),
identifying:jspb.Message.getFieldWithDefault(msg,12,false),
lockOpen:jspb.Message.getFieldWithDefault(msg,13,false),
lockStuck:jspb.Message.getFieldWithDefault(msg,14,false),
lockArmed:jspb.Message.getFieldWithDefault(msg,17,false),
lockLocked:jspb.Message.getFieldWithDefault(msg,20,false),
lockAlarming:jspb.Message.getFieldWithDefault(msg,15,false),
lockDoorAlarm:jspb.Message.getFieldWithDefault(msg,23,false),
lockPullAlarm:jspb.Message.getFieldWithDefault(msg,24,false),
authorizedUserKeyUsed:jspb.Message.getFieldWithDefault(msg,21,false),
lockBatteryLevel:jspb.Message.getFieldWithDefault(msg,16,0),
silentAlarming:jspb.Message.getFieldWithDefault(msg,25,false),
keySerialNumber:jspb.Message.getFieldWithDefault(msg,18,""),
keyType:jspb.Message.getFieldWithDefault(msg,19,0),
failureType:jspb.Message.getFieldWithDefault(msg,22,0)};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.lock.State.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.lock.State();
return proto.mti.store.lock.State.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.lock.State.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=new mti_metadata_pb.Metadata();
reader.readMessage(value,mti_metadata_pb.Metadata.deserializeBinaryFromReader);
msg.setMetadata(value);
break;
case 2:
var value=reader.readUint64();
msg.setStoreId(value);
break;
case 3:
var value=reader.readString();
msg.setSerialNumber(value);
break;
case 4:
var value=reader.readUint32();
msg.setLockIndex(value);
break;
case 5:
var value=reader.readBytes();
msg.setStateUuid(value);
break;
case 6:
var value=new google_protobuf_timestamp_pb.Timestamp();
reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
msg.setStateUpdatedAt(value);
break;
case 7:
var value=reader.readEnum();
msg.setType(value);
break;
case 8:
var value=reader.readString();
msg.setLockModel(value);
break;
case 9:
var value=reader.readString();
msg.setLockHardwareVersion(value);
break;
case 10:
var value=reader.readString();
msg.setLockFirmwareVersion(value);
break;
case 11:
var value=reader.readBool();
msg.setLostCommunication(value);
break;
case 12:
var value=reader.readBool();
msg.setIdentifying(value);
break;
case 13:
var value=reader.readBool();
msg.setLockOpen(value);
break;
case 14:
var value=reader.readBool();
msg.setLockStuck(value);
break;
case 17:
var value=reader.readBool();
msg.setLockArmed(value);
break;
case 20:
var value=reader.readBool();
msg.setLockLocked(value);
break;
case 15:
var value=reader.readBool();
msg.setLockAlarming(value);
break;
case 23:
var value=reader.readBool();
msg.setLockDoorAlarm(value);
break;
case 24:
var value=reader.readBool();
msg.setLockPullAlarm(value);
break;
case 21:
var value=reader.readBool();
msg.setAuthorizedUserKeyUsed(value);
break;
case 16:
var value=reader.readUint32();
msg.setLockBatteryLevel(value);
break;
case 25:
var value=reader.readBool();
msg.setSilentAlarming(value);
break;
case 18:
var value=reader.readString();
msg.setKeySerialNumber(value);
break;
case 19:
var value=reader.readEnum();
msg.setKeyType(value);
break;
case 22:
var value=reader.readEnum();
msg.setFailureType(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.lock.State.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.lock.State.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.lock.State.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getMetadata();
if(f!=null){
writer.writeMessage(
1,
f,
mti_metadata_pb.Metadata.serializeBinaryToWriter);

}
f=message.getStoreId();
if(f!==0){
writer.writeUint64(
2,
f);

}
f=message.getSerialNumber();
if(f.length>0){
writer.writeString(
3,
f);

}
f=message.getLockIndex();
if(f!==0){
writer.writeUint32(
4,
f);

}
f=message.getStateUuid_asU8();
if(f.length>0){
writer.writeBytes(
5,
f);

}
f=message.getStateUpdatedAt();
if(f!=null){
writer.writeMessage(
6,
f,
google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);

}
f=message.getType();
if(f!==0.0){
writer.writeEnum(
7,
f);

}
f=message.getLockModel();
if(f.length>0){
writer.writeString(
8,
f);

}
f=message.getLockHardwareVersion();
if(f.length>0){
writer.writeString(
9,
f);

}
f=message.getLockFirmwareVersion();
if(f.length>0){
writer.writeString(
10,
f);

}
f=message.getLostCommunication();
if(f){
writer.writeBool(
11,
f);

}
f=message.getIdentifying();
if(f){
writer.writeBool(
12,
f);

}
f=message.getLockOpen();
if(f){
writer.writeBool(
13,
f);

}
f=message.getLockStuck();
if(f){
writer.writeBool(
14,
f);

}
f=message.getLockArmed();
if(f){
writer.writeBool(
17,
f);

}
f=message.getLockLocked();
if(f){
writer.writeBool(
20,
f);

}
f=message.getLockAlarming();
if(f){
writer.writeBool(
15,
f);

}
f=message.getLockDoorAlarm();
if(f){
writer.writeBool(
23,
f);

}
f=message.getLockPullAlarm();
if(f){
writer.writeBool(
24,
f);

}
f=message.getAuthorizedUserKeyUsed();
if(f){
writer.writeBool(
21,
f);

}
f=message.getLockBatteryLevel();
if(f!==0){
writer.writeUint32(
16,
f);

}
f=message.getSilentAlarming();
if(f){
writer.writeBool(
25,
f);

}
f=message.getKeySerialNumber();
if(f.length>0){
writer.writeString(
18,
f);

}
f=message.getKeyType();
if(f!==0.0){
writer.writeEnum(
19,
f);

}
f=message.getFailureType();
if(f!==0.0){
writer.writeEnum(
22,
f);

}
};






proto.mti.store.lock.State.prototype.getMetadata=function(){
return(
jspb.Message.getWrapperField(this,mti_metadata_pb.Metadata,1));
};



proto.mti.store.lock.State.prototype.setMetadata=function(value){
jspb.Message.setWrapperField(this,1,value);
};


proto.mti.store.lock.State.prototype.clearMetadata=function(){
this.setMetadata(undefined);
};






proto.mti.store.lock.State.prototype.hasMetadata=function(){
return jspb.Message.getField(this,1)!=null;
};






proto.mti.store.lock.State.prototype.getStoreId=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.store.lock.State.prototype.setStoreId=function(value){
jspb.Message.setProto3IntField(this,2,value);
};






proto.mti.store.lock.State.prototype.getSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,3,"");
};



proto.mti.store.lock.State.prototype.setSerialNumber=function(value){
jspb.Message.setProto3StringField(this,3,value);
};






proto.mti.store.lock.State.prototype.getLockIndex=function(){
return jspb.Message.getFieldWithDefault(this,4,0);
};



proto.mti.store.lock.State.prototype.setLockIndex=function(value){
jspb.Message.setProto3IntField(this,4,value);
};






proto.mti.store.lock.State.prototype.getStateUuid=function(){
return jspb.Message.getFieldWithDefault(this,5,"");
};







proto.mti.store.lock.State.prototype.getStateUuid_asB64=function(){
return jspb.Message.bytesAsB64(
this.getStateUuid());
};









proto.mti.store.lock.State.prototype.getStateUuid_asU8=function(){
return jspb.Message.bytesAsU8(
this.getStateUuid());
};



proto.mti.store.lock.State.prototype.setStateUuid=function(value){
jspb.Message.setProto3BytesField(this,5,value);
};






proto.mti.store.lock.State.prototype.getStateUpdatedAt=function(){
return(
jspb.Message.getWrapperField(this,google_protobuf_timestamp_pb.Timestamp,6));
};



proto.mti.store.lock.State.prototype.setStateUpdatedAt=function(value){
jspb.Message.setWrapperField(this,6,value);
};


proto.mti.store.lock.State.prototype.clearStateUpdatedAt=function(){
this.setStateUpdatedAt(undefined);
};






proto.mti.store.lock.State.prototype.hasStateUpdatedAt=function(){
return jspb.Message.getField(this,6)!=null;
};






proto.mti.store.lock.State.prototype.getType=function(){
return jspb.Message.getFieldWithDefault(this,7,0);
};



proto.mti.store.lock.State.prototype.setType=function(value){
jspb.Message.setProto3EnumField(this,7,value);
};






proto.mti.store.lock.State.prototype.getLockModel=function(){
return jspb.Message.getFieldWithDefault(this,8,"");
};



proto.mti.store.lock.State.prototype.setLockModel=function(value){
jspb.Message.setProto3StringField(this,8,value);
};






proto.mti.store.lock.State.prototype.getLockHardwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,9,"");
};



proto.mti.store.lock.State.prototype.setLockHardwareVersion=function(value){
jspb.Message.setProto3StringField(this,9,value);
};






proto.mti.store.lock.State.prototype.getLockFirmwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,10,"");
};



proto.mti.store.lock.State.prototype.setLockFirmwareVersion=function(value){
jspb.Message.setProto3StringField(this,10,value);
};








proto.mti.store.lock.State.prototype.getLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,11,false);
};



proto.mti.store.lock.State.prototype.setLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,11,value);
};








proto.mti.store.lock.State.prototype.getIdentifying=function(){
return jspb.Message.getFieldWithDefault(this,12,false);
};



proto.mti.store.lock.State.prototype.setIdentifying=function(value){
jspb.Message.setProto3BooleanField(this,12,value);
};








proto.mti.store.lock.State.prototype.getLockOpen=function(){
return jspb.Message.getFieldWithDefault(this,13,false);
};



proto.mti.store.lock.State.prototype.setLockOpen=function(value){
jspb.Message.setProto3BooleanField(this,13,value);
};








proto.mti.store.lock.State.prototype.getLockStuck=function(){
return jspb.Message.getFieldWithDefault(this,14,false);
};



proto.mti.store.lock.State.prototype.setLockStuck=function(value){
jspb.Message.setProto3BooleanField(this,14,value);
};








proto.mti.store.lock.State.prototype.getLockArmed=function(){
return jspb.Message.getFieldWithDefault(this,17,false);
};



proto.mti.store.lock.State.prototype.setLockArmed=function(value){
jspb.Message.setProto3BooleanField(this,17,value);
};








proto.mti.store.lock.State.prototype.getLockLocked=function(){
return jspb.Message.getFieldWithDefault(this,20,false);
};



proto.mti.store.lock.State.prototype.setLockLocked=function(value){
jspb.Message.setProto3BooleanField(this,20,value);
};








proto.mti.store.lock.State.prototype.getLockAlarming=function(){
return jspb.Message.getFieldWithDefault(this,15,false);
};



proto.mti.store.lock.State.prototype.setLockAlarming=function(value){
jspb.Message.setProto3BooleanField(this,15,value);
};








proto.mti.store.lock.State.prototype.getLockDoorAlarm=function(){
return jspb.Message.getFieldWithDefault(this,23,false);
};



proto.mti.store.lock.State.prototype.setLockDoorAlarm=function(value){
jspb.Message.setProto3BooleanField(this,23,value);
};








proto.mti.store.lock.State.prototype.getLockPullAlarm=function(){
return jspb.Message.getFieldWithDefault(this,24,false);
};



proto.mti.store.lock.State.prototype.setLockPullAlarm=function(value){
jspb.Message.setProto3BooleanField(this,24,value);
};








proto.mti.store.lock.State.prototype.getAuthorizedUserKeyUsed=function(){
return jspb.Message.getFieldWithDefault(this,21,false);
};



proto.mti.store.lock.State.prototype.setAuthorizedUserKeyUsed=function(value){
jspb.Message.setProto3BooleanField(this,21,value);
};






proto.mti.store.lock.State.prototype.getLockBatteryLevel=function(){
return jspb.Message.getFieldWithDefault(this,16,0);
};



proto.mti.store.lock.State.prototype.setLockBatteryLevel=function(value){
jspb.Message.setProto3IntField(this,16,value);
};








proto.mti.store.lock.State.prototype.getSilentAlarming=function(){
return jspb.Message.getFieldWithDefault(this,25,false);
};



proto.mti.store.lock.State.prototype.setSilentAlarming=function(value){
jspb.Message.setProto3BooleanField(this,25,value);
};






proto.mti.store.lock.State.prototype.getKeySerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,18,"");
};



proto.mti.store.lock.State.prototype.setKeySerialNumber=function(value){
jspb.Message.setProto3StringField(this,18,value);
};






proto.mti.store.lock.State.prototype.getKeyType=function(){
return jspb.Message.getFieldWithDefault(this,19,0);
};



proto.mti.store.lock.State.prototype.setKeyType=function(value){
jspb.Message.setProto3EnumField(this,19,value);
};






proto.mti.store.lock.State.prototype.getFailureType=function(){
return jspb.Message.getFieldWithDefault(this,22,0);
};



proto.mti.store.lock.State.prototype.setFailureType=function(value){
jspb.Message.setProto3EnumField(this,22,value);
};





proto.mti.store.lock.Type={
POWERED:0,
BATTERY:1};





proto.mti.store.lock.PhysicalKeyType={
NONE:0,
USB_BACKUP:1,
USB_NETWORK:2,
RFID_USER:3,
RFID_PROGRAMMING:4,
RFID_FACTORY_RESET:5,
RFID_CONNECT:6};





proto.mti.store.lock.LockFailureType={
FAIL_OPEN:0,
FAIL_SECURE:1};


goog.object.extend(exports,proto.mti.store.lock);